module.exports = __webpack_public_path__ + "static/media/help_Fondos.cabb9428.png";